export const uk = {
    moscow: 'Москва',
    'phone-extension': 'доб. {phone}',
    regions: 'Регионы'
};
